import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';
import { injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

import PricingList from '../../../../components/SiteAdmin/Pricing/PricingList';
import Loader from '../../../../components/Common/Loader/Loader';

import getAllPricingQuery from './getAllPricing.graphql';
import messages from '../../../../locale/messages';

import s from './Pricing.css';

class Pricing extends React.Component {

  render() {
    const { formatMessage } = this.props.intl;
    const { pricingDetails, pricingDetails: { loading } } = this.props;

    return (
      <Loader type={"page"} show={loading}>
        <div className={s.root}>
          {!loading && <div className={s.container}>
            <div className={cx(s.heading, 'textAlignRightRTL', 'textWhite')}>
              {formatMessage(messages.manageFare)}
            </div>
            <div className={s.paddingRoutesSection}>
              <PricingList pricingDetails={pricingDetails} />
            </div>
          </div>}
        </div>
      </Loader>
    );
  }
}

export default compose(
  injectIntl,
  withStyles(s),
  graphql(getAllPricingQuery, {
    name: 'pricingDetails',
    options: {
      ssr: true,
      fetchPolicy: 'network-only',
      variables: {
        currentPage: 1,
        searchKeyword: ''
      }
    }
  }))(Pricing);
